import { RemoteGetGroupById } from 'data/usecases';
import { GetGroupByIdUseCaseInterface } from 'domain/usecases';
import { makeApiUrlGroupList } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteGetGroupById = (): GetGroupByIdUseCaseInterface =>
  new RemoteGetGroupById(makeApiUrlGroupList(), makeAxiosHttpClient());
